import * as React from 'react';
import styled from '@emotion/styled';
import { motion, AnimatePresence } from 'framer-motion';

import { tokens } from '@hotjar/hotsauce';

const SpinnerContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 21;
`;

const Container = styled(motion.div)`
  z-index: 21;
  background: ${tokens.BRAND_COLORS.neutral_200};
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

interface Props {
  isLoading: boolean;
}

export const LoadingScreen = ({ isLoading }: Props): JSX.Element => {
  return (
    <AnimatePresence initial>
      {isLoading && (
        <Container animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <SpinnerContainer>
            <div id="recording-spinner" />
          </SpinnerContainer>
        </Container>
      )}
    </AnimatePresence>
  );
};
